import { FC } from 'react';
import { DialogActions as MuiDialogActions, DialogActionsProps } from '@mui/material';

export const DialogActions: FC<DialogActionsProps> = ({ children, ...props }) => {
  return <MuiDialogActions {...props}>{children}</MuiDialogActions>;
};
